<template>
    <section class="content-section">
        <b-container fluid>
            <b-row class="justify-content-center">
                <b-col cols="12" md="10">
                    <h3 class="ada-h3 mb-4">{{adapters.title}}</h3>
                    <AdapterOwl :adapters="adapters.items" lg="6" />
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
import AdapterOwl from '@/components/AdapterOwl'

export default {
    components: { AdapterOwl },
    props: ['adapters']
}
</script>

<style lang="scss">
    .ada-h3 {
        color:$color-main
    }
</style>